import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

/** 
 * Returns an axios instance for API calls with default configuration.
 */
export function createAxiosInstance(options?: AxiosRequestConfig): AxiosInstance 
{
  return axios.create({ baseURL: '/api/proxy', timeout: 30_000, ...options });
}